<a>
  <span ng-bind-html="match.model.employeeName | uibTypeaheadHighlight:query"></span>
  <span ng-bind-html="match.model.employeePersonnelNumber | uibTypeaheadHighlight:query"></span>
  <span class="second-column" ng-bind-html="match.model.employeeOrgUnitName | uibTypeaheadHighlight:query"></span>
</a>
